module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    staticClass: "header-booking-data",
    attrs: {
      "wrap": "",
      "justify-end": "",
      "align-center": ""
    }
  }, [_c('amounts-component', {
    attrs: {
      "subsidiary-id": _vm.subsidiary
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "hide-details": "",
      "items": _vm.subsidiaries,
      "item-text": "name",
      "item-value": "id",
      "single-line": ""
    },
    on: {
      "input": _vm.loadTypeRooms,
      "change": _vm.onChangeSubsidiary
    },
    model: {
      value: (_vm.subsidiary),
      callback: function($$v) {
        _vm.subsidiary = $$v
      },
      expression: "subsidiary"
    }
  })], 1)], 1), _vm._v(" "), (_vm.bookingCode && _vm.bookingSelected && _vm.bookingSelected.summary &&
    _vm.bookingSelected.summary.personalInformation) ? _c('v-layout', {
    staticClass: "header-booking-data header-booking-data-calendar",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": "",
      "pr-3": ""
    }
  }, [_c('p', [_vm._v("Cliente")]), _vm._v(" "), _c('span', [_vm._v("\n\t\t\t\t" + _vm._s(_vm.bookingSelected.summary.personalInformation.name) + "\n\t\t\t\t" + _vm._s(_vm.bookingSelected.summary.personalInformation.lastName) + "\n\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('p', [_vm._v("Cod. Reserva")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.bookingCode))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": "",
      "pr-3": ""
    }
  }, [_c('p', [_vm._v("Habitación")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.bookingSelected.summary.personalInformation.roomTypeCode) + " " + _vm._s(_vm.roomList.codeRoom))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "pr-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select filter-header-calendar",
    attrs: {
      "items": _vm.roomsList,
      "label": "Nº",
      "item-text": "codeRoom",
      "disabled": _vm.roomsList.length === 0,
      "hide-details": "",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.roomList),
      callback: function($$v) {
        _vm.roomList = $$v
      },
      expression: "roomList"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-btn', {
    staticClass: "assign-room",
    attrs: {
      "type": "button",
      "disabled": !_vm.roomList
    },
    on: {
      "click": _vm.assignBooking
    }
  }, [_vm._v("\n\t\t\t\t\t\tAsignar\n\t\t\t\t\t")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container-calendar mt-3"
  }, [_c('div', {
    staticClass: "tasks-calendar-header"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "pr-2": ""
    }
  }, [_c('v-layout', {
    staticClass: "calendar-range",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "border-right",
    attrs: {
      "md6": "",
      "pa-0": ""
    }
  }, [_c('v-menu', {
    staticClass: "menu-date-picker",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    on: {
      "input": _vm.changeIcon
    },
    model: {
      value: (_vm.menuStart),
      callback: function($$v) {
        _vm.menuStart = $$v
      },
      expression: "menuStart"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Picker in menu",
      "prepend-icon": "event",
      "append-icon": _vm.arrowIconStart,
      "append-icon-cb": _vm.toggleIconStartDate,
      "single-line": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.dateStart),
      callback: function($$v) {
        _vm.dateStart = $$v
      },
      expression: "dateStart"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "es-PE",
      "date-format": _vm.changeFormatDate,
      "formatted-value": _vm.formatted,
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.dateStart),
      callback: function($$v) {
        _vm.dateStart = $$v
      },
      expression: "dateStart"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "py-0": "",
      "pl-1": ""
    }
  }, [_c('v-menu', {
    staticClass: "menu-date-picker",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "max-width": "290px"
    },
    on: {
      "input": _vm.changeEndIcon
    },
    model: {
      value: (_vm.menuEnd),
      callback: function($$v) {
        _vm.menuEnd = $$v
      },
      expression: "menuEnd"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Picker in menu",
      "append-icon": _vm.arrowIconEnd,
      "append-icon-cb": _vm.toggleIconEndDate,
      "single-line": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.dateEnd),
      callback: function($$v) {
        _vm.dateEnd = $$v
      },
      expression: "dateEnd"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "es-PE",
      "date-format": _vm.changeFormatDate,
      "formatted-value": _vm.formatted,
      "no-title": "",
      "scrollable": "",
      "allowed-dates": function (date) { return _vm.isAfterMethod(date, _vm.dateStart); }
    },
    on: {
      "input": _vm.showDates
    },
    model: {
      value: (_vm.dateEnd),
      callback: function($$v) {
        _vm.dateEnd = $$v
      },
      expression: "dateEnd"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-layout', {
    staticClass: "caption",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-start": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('span', {
    staticClass: "color check-in"
  }), _vm._v(" "), _c('label', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tCheck In\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('span', {
    staticClass: "color check-out"
  }), _vm._v(" "), _c('label', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tCheck Out\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('span', {
    staticClass: "color taken"
  }), _vm._v(" "), _c('label', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tReservada\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('span', {
    staticClass: "color locked"
  }), _vm._v(" "), _c('label', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tBloqueada\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('span', {
    staticClass: "color in-house"
  }), _vm._v(" "), _c('label', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tIn House\n\t\t\t\t\t\t\t")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-layout', {
    staticClass: "container-actualizar",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "pr-3": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-action btn-darkblue white--text",
    attrs: {
      "small": ""
    },
    on: {
      "click": _vm.loadAvailability
    }
  }, [_c('v-icon', [_vm._v("autorenew")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('button-create', {
    attrs: {
      "text": "Crear reserva",
      "btn-function": true
    },
    on: {
      "function-click": _vm.goToBookingNew
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    ref: "base-calendar",
    staticClass: "base-calendar"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDateBarFixed),
      expression: "showDateBarFixed"
    }],
    ref: "bar-fixed",
    staticClass: "date-bar-fixed"
  }, [_c('div', {
    staticClass: "row-calendar row-days row-taken-bar"
  }, _vm._l((_vm.monthSelected.days), function(day) {
    return _c('div', {
      key: day.id,
      staticClass: "col-calendar col-calendar-1"
    }, [_c('p', [_vm._v(_vm._s(day.shortDay))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(day.day))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "thead-calendar"
  }, [_c('div', {
    staticClass: "main-row"
  }, [_c('div', {
    ref: "col",
    staticClass: "col-calendar col-calendar-4"
  }, [_c('div', {
    staticClass: "row-calendar row-left row-taken-bar"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('v-select', {
    staticClass: "filter-select select-roomtype",
    attrs: {
      "label": "Tipo de Habitación",
      "hide-details": "",
      "item-text": "codeRoomtype",
      "item-value": "id",
      "single-line": "",
      "items": _vm.roomTypes
    },
    on: {
      "change": _vm.loadData
    },
    model: {
      value: (_vm.roomTypeSelected),
      callback: function($$v) {
        _vm.roomTypeSelected = $$v
      },
      expression: "roomTypeSelected"
    }
  })], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.rooms), function(room) {
    return _c('div', {
      key: room.id,
      staticClass: "row-calendar row-rooms row-left"
    }, [_c('p', {
      staticClass: "row-rooms-text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(room.typeRoom.code) + " " + _vm._s(room.codeRoom) + "\n\t\t\t\t\t\t\t")])])
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)], 2), _vm._v(" "), _c('div', {
    ref: "col-calendar-31",
    staticClass: "col-calendar col-calendar-31"
  }, [_c('div', {
    ref: "movil-date",
    staticClass: "row-calendar row-days row-taken-bar",
    attrs: {
      "id": "movil-date"
    }
  }, _vm._l((_vm.monthSelected.days), function(day) {
    return _c('div', {
      key: day.id,
      staticClass: "col-calendar col-calendar-1"
    }, [_c('p', [_vm._v(_vm._s(day.shortDay))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(day.day))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "row-calendar row-days row-taken-bar"
  }, _vm._l((_vm.roomsTaken), function(taken, takenIndex) {
    return _c('div', {
      key: takenIndex,
      staticClass: "col-calendar col-calendar-1 py-1"
    }, [_c('p', [_vm._v(_vm._s(taken.percent) + "%")])])
  })), _vm._v(" "), _vm._l((_vm.rooms), function(room) {
    return _c('div', {
      key: room.id,
      staticClass: "row-calendar row-calendar-body"
    }, _vm._l((_vm.monthSelected.days), function(day, dayIndex) {
      return _c('div', {
        key: day.id,
        staticClass: "col-calendar col-calendar-1",
        class: {
          'day-is-weekend': day.isWeekend,
            'day-is-selected': day.isSelected && room.isSelected,
            'day-is-taken': _vm.dayTaken(room, day)
        }
      }, [(_vm.dayTaken(room, day)) ? _c('div', {
        staticClass: "tag-container",
        attrs: {
          "draggable": "true",
          "droppable": "true"
        },
        on: {
          "dragover": function($event) {
            $event.preventDefault();
          },
          "drag": function($event) {
            _vm.dragEvent(room, day)
          },
          "drop": function($event) {
            _vm.dropEvent(room, day, $event)
          },
          "click": function($event) {
            $event.stopPropagation();
            _vm.newBooking($event, day, room)
          }
        }
      }, _vm._l((room.customers), function(customer, customerIndex) {
        return (_vm.validationTakenDay(customer, day)) ? _c('div', {
          key: customerIndex,
          staticClass: "tag",
          class: {
            'tag-init-day': customer.initDay === day.day,
              'tag-end-day': customer.endDay === day.day,
              'z-index': dayIndex === 0 && _vm.showName(dayIndex, customer, day.day)
          },
          style: (("background-color: " + (customer.color) + ";")),
          attrs: {
            "readonly": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.showCustomerInfo($event, room, customer, day)
            }
          }
        }, [(customer.initDay === day.day || _vm.showName(dayIndex, customer, day.day)) ? _c('span', {
          staticClass: "tag-name",
          style: (("max-width: calc((100% * " + (_vm.calculateLength(dayIndex, customer, day.day)) + ") - 18px)"))
        }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(customer.lastname) + " " + _vm._s(customer.name) + "\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()]) : _vm._e()
      })) : _vm._e(), _vm._v(" "), (_vm.newRanges.length !== 1 ||
        (_vm.newRanges[0] &&
          _vm.methodIsAfter(_vm.newRanges[0].day.date, day.date)) ||
        (_vm.newRanges[0] && (_vm.newRanges[0].room.id !== room.id)) ||
        (_vm.newRanges[0] &&
          _vm.methodIsSameDay(_vm.newRanges[0].day.date, day.date))) ? _c('div', {
        staticClass: "tag-container no-tag",
        attrs: {
          "draggable": "true",
          "droppable": "true"
        },
        on: {
          "dragover": function($event) {
            $event.preventDefault();
          },
          "drag": function($event) {
            _vm.dragEvent(room, day)
          },
          "drop": function($event) {
            _vm.dropEvent(room, day, $event)
          },
          "click": function($event) {
            $event.stopPropagation();
            _vm.newBooking($event, day, room)
          }
        }
      }) : _c('div', {
        staticClass: "tag-container no-tag",
        attrs: {
          "draggable": "true",
          "droppable": "true"
        },
        on: {
          "dragover": function($event) {
            $event.preventDefault();
          },
          "drag": function($event) {
            _vm.dragEvent(room, day)
          },
          "drop": function($event) {
            _vm.dropEvent(room, day, $event)
          },
          "click": function($event) {
            $event.stopPropagation();
            _vm.newBooking($event, day, room)
          }
        }
      })])
    }))
  }), _vm._v(" "), _c('div', {
    staticClass: "row-calendar row-calendar-footer"
  }, _vm._l((_vm.freeRooms), function(free, freeIndex) {
    return _c('div', {
      key: freeIndex,
      staticClass: "col-calendar col-calendar-1"
    }, [_c('p', {
      staticClass: "text-footer"
    }, [_vm._v(_vm._s(free.free))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "row-calendar row-calendar-footer"
  }, _vm._l((_vm.freeRooms), function(free, freeIndex) {
    return _c('div', {
      key: freeIndex,
      staticClass: "col-calendar col-calendar-1"
    }, [_c('p', {
      staticClass: "text-footer"
    }, [_vm._v(_vm._s(free.currency) + _vm._s(_vm._f("round")(free.price)))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "row-calendar row-calendar-footer row-calendar-total-availability"
  }, [_c('general-availability', {
    attrs: {
      "free-rooms": _vm.freeRooms,
      "subsidiary-id": _vm.subsidiary,
      "month-selected": _vm.monthSelected
    }
  })], 1)], 2)])])], 1)]), _vm._v(" "), _c('v-menu', {
    staticClass: "tag-menu-modal",
    attrs: {
      "content-class": "tag-menu-content",
      "min-width": "368",
      "nudge-top": 145,
      "nudge-left": 40,
      "position-absolutely": "",
      "position-x": _vm.xBooking,
      "position-y": _vm.yBooking,
      "z-index": "10"
    },
    model: {
      value: (_vm.menuBooking),
      callback: function($$v) {
        _vm.menuBooking = $$v
      },
      expression: "menuBooking"
    }
  }, [_c('v-list', {
    staticClass: "py-0 tag-menu-header"
  }, [_c('v-list-tile', [_c('v-list-tile-title', {
    staticClass: "tag-menu-title"
  }, [_vm._v("\n\t\t\t\t\tCheck in\n\t\t\t\t")]), _vm._v(" "), _c('v-list-tile-action', {
    staticClass: "justify-end"
  }, [_c('v-btn', {
    staticClass: "grey--text size-btn",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closeMenuBooking
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "tag-menu-border",
    attrs: {
      "xs7": ""
    }
  }, [_c('v-list', {
    staticClass: "tag-menu-body"
  }, [_c('v-list-tile', [_c('v-list-tile-title', [_c('label', [_vm._v("Booking ID:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.customerInfo.customer.numReservation))])])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', [_c('label', [_vm._v("Nombre:")]), _vm._v(" "), _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.customerInfo.customer.name) + "\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.customerInfo.customer.lastname) + "\n\t\t\t\t\t\t\t")])])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', [_c('label', [_vm._v("País:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.customerInfo.customer.country))])])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', [_c('label', [_vm._v("Check-in Date:")]), _vm._v(" "), _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("parseDate")(_vm.customerInfo.customer.dateRange[0])) + "\n\t\t\t\t\t\t\t")])])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', [_c('label', [_vm._v("Check-out date:")]), _vm._v(" "), _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("parseDate")(_vm.customerInfo.customer.dateRange[1])) + "\n\t\t\t\t\t\t\t")])])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', [_c('label', [_vm._v("Hora de salida:")]), _vm._v(" "), _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.getCheckoutHours(_vm.customerInfo.customer.dateRange[1])) + "\n\t\t\t\t\t\t\t")])])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', [_c('label', [_vm._v("Exonerado:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.customerInfo.exonerated))])])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', [_c('label', [_vm._v("Pago sin igv:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("round")(_vm.customerInfo.customer.total)))])])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', [_c('label', [_vm._v("Pago total:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("round")(_vm.customerInfo.customer.totalIgv)))])])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', [_c('label', [_vm._v("Consumo:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("round")(_vm.customerInfo.customer.subTotalConsumptions)))])])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', [_c('label', [_vm._v("Adultos:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.customerInfo.customer.adults))])])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', [_c('label', [_vm._v("Niños:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.customerInfo.customer.childrens))])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-list', {
    staticClass: "tag-menu-sidebar"
  }, [_c('v-list-tile', {
    on: {
      "click": _vm.seeBooking
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("remove_red_eye")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Visualizar")])], 1), _vm._v(" "), ((Number(_vm.customerInfo.customer.bookingState) === 4 &&
      !_vm.expiredReservation) ||
    (Number(_vm.customerInfo.customer.bookingState) === 1 &&
      !_vm.expiredReservation)) ? _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.goToCheckIn(_vm.customerInfo.room.comSubsidiaryId,
          _vm.customerInfo.room.hotMsRoomtypeId)
      }
    }
  }, [_c('v-list-tile-action', [_c('img', {
    attrs: {
      "src": (_vm.$imageS3 + "/clerkinn/checkin-icon.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Check in")])], 1) : _vm._e(), _vm._v(" "), (_vm.validationCheckOut(_vm.customerInfo)) ? _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.goToCheckOut(_vm.customerInfo.room.comSubsidiaryId,
          _vm.customerInfo.room.hotMsRoomtypeId)
      }
    }
  }, [_c('v-list-tile-action', [_c('img', {
    attrs: {
      "src": (_vm.$imageS3 + "/clerkinn/checkout-icon.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Check Out")])], 1) : _vm._e(), _vm._v(" "), (_vm.noShowOption(_vm.customerInfo)) ? _c('v-list-tile', {
    on: {
      "click": _vm.openNoShowBooking
    }
  }, [_c('v-list-tile-action', [_c('img', {
    attrs: {
      "src": (_vm.$imageS3 + "/clerkinn/no-show-icon.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-list-tile-title', [_vm._v("No show")])], 1) : _vm._e(), _vm._v(" "), (Number(_vm.customerInfo.customer.bookingState) === 1 ||
    Number(_vm.customerInfo.customer.bookingState) === 4) ? _c('v-list-tile', {
    on: {
      "click": _vm.openCancelBooking
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    staticClass: "red--text"
  }, [_vm._v("cancel")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Anular")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": _vm.downloadCardTravel
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("print")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Tarjeta de Embarque")])], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.goToBilling(_vm.customerInfo.room.comSubsidiaryId,
          _vm.customerInfo.room.hotMsRoomtypeId)
      }
    }
  }, [_c('v-list-tile-action', [_c('img', {
    attrs: {
      "src": (_vm.$imageS3 + "/clerkinn/billing-icon.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Factura")])], 1), _vm._v(" "), (_vm.validationAdvancePayment(_vm.customerInfo)) ? _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.goToPrepayment(_vm.customerInfo)
      }
    }
  }, [_c('v-list-tile-action', [_c('img', {
    attrs: {
      "src": (_vm.$imageS3 + "/clerkinn/pay-icon.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Adelanto")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.goToDetailGuest(_vm.customerInfo.room.comSubsidiaryId,
          _vm.customerInfo.room.hotMsRoomtypeId)
      }
    }
  }, [_c('v-list-tile-action', [_c('img', {
    attrs: {
      "src": (_vm.$imageS3 + "/clerkinn/billing-icon.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Detalle de Huésped")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-menu', {
    staticClass: "tag-menu-modal new-booking",
    attrs: {
      "content-class": "tag-menu-content new-booking",
      "position-absolutely": "",
      "min-width": "148",
      "position-x": _vm.xNewBooking,
      "position-y": _vm.yNewBooking,
      "nudge-top": 36,
      "nudge-left": 20
    },
    model: {
      value: (_vm.menuNewBooking),
      callback: function($$v) {
        _vm.menuNewBooking = $$v
      },
      expression: "menuNewBooking"
    }
  }, [_c('v-list', {
    staticClass: "py-0 tag-menu-header"
  }, [_c('v-list-tile', [_c('v-list-tile-title', {
    staticClass: "tag-menu-title"
  }, [_vm._v("\n\t\t\t\t\tReserva\n\t\t\t\t")]), _vm._v(" "), _c('v-list-tile-action', {
    staticClass: "justify-end"
  }, [_c('v-btn', {
    staticClass: "grey--text size-btn",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closeMenuNew
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-list', {
    staticClass: "tag-menu-sidebar"
  }, [_c('v-list-tile', {
    on: {
      "click": _vm.goToReserve
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Agregar")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "480px"
    },
    model: {
      value: (_vm.modalCancelBooking),
      callback: function($$v) {
        _vm.modalCancelBooking = $$v
      },
      expression: "modalCancelBooking"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline py-2 px-5"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "text-xs-left": ""
    }
  }, [_c('p', {
    staticClass: "headline-title"
  }, [_vm._v("\n\t\t\t\t\t\t\tAnulación de reserva\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "text-xs-right": ""
    }
  }, [_c('label', {
    staticClass: "headline-label"
  }, [_vm._v("\n\t\t\t\t\t\t\tFecha:\n\t\t\t\t\t\t")]), _vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.today) + "\n\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-5"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Motivo")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    model: {
      value: (_vm.cancelModel.title),
      callback: function($$v) {
        _vm.cancelModel.title = $$v
      },
      expression: "cancelModel.title"
    }
  }), _vm._v(" "), (_vm.$v.cancelModel.title && _vm.$v.cancelModel.title.$invalid) ? _c('span', {
    staticClass: "caption red--text"
  }, [_vm._v("\n\t\t\t\t\t\t\tEl motivo de anulación es requerido\n\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-3": ""
    }
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Descripción")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset input-textarea input-note",
    attrs: {
      "no-resize": "",
      "multi-line": "",
      "rows": 3,
      "textarea": ""
    },
    model: {
      value: (_vm.cancelModel.description),
      callback: function($$v) {
        _vm.cancelModel.description = $$v
      },
      expression: "cancelModel.description"
    }
  }), _vm._v(" "), (_vm.$v.cancelModel.description && _vm.$v.cancelModel.description.$invalid) ? _c('span', {
    staticClass: "caption red--text"
  }, [_vm._v("\n\t\t\t\t\t\t\tLa descripción de la anulación es requerida\n\t\t\t\t\t\t")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "pr-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-cancel grey",
    nativeOn: {
      "click": function($event) {
        _vm.closeBookingModal('Cancel')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tCancelar\n\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "pl-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-save",
    attrs: {
      "disabled": _vm.$v.$invalid
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelBooking($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tAceptar\n\t\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "380px"
    },
    model: {
      value: (_vm.modalNoShowBooking),
      callback: function($$v) {
        _vm.modalNoShowBooking = $$v
      },
      expression: "modalNoShowBooking"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline py-2 px-4"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": ""
    }
  }, [_c('p', {
    staticClass: "headline-title"
  }, [_vm._v("\n\t\t\t\t\t\t\tNo-show de reserva\n\t\t\t\t\t\t")])])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-4"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    staticClass: "headline-label"
  }, [_vm._v("\n\t\t\t\t\t\t\tBooking ID:\n\t\t\t\t\t\t")]), _vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.noShowModel.codeBooking) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    staticClass: "headline-label"
  }, [_vm._v("\n\t\t\t\t\t\t\tNombre:\n\t\t\t\t\t\t")]), _vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.customerInfo.customer.name) + "\n\t\t\t\t\t\t" + _vm._s(_vm.customerInfo.customer.lastname) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "mt-2": ""
    }
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("No-show")]), _vm._v(" "), _c('v-menu', {
    staticClass: "menu-date-picker mt-2",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "max-width": "290px"
    },
    on: {
      "input": _vm.changeIconDate
    },
    model: {
      value: (_vm.noShowDate),
      callback: function($$v) {
        _vm.noShowDate = $$v
      },
      expression: "noShowDate"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fecha de nacimiento",
      "prepend-icon": "event",
      "append-icon": _vm.arrowIcon,
      "single-line": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.noShowModel.date),
      callback: function($$v) {
        _vm.noShowModel.date = $$v
      },
      expression: "noShowModel.date"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "es-PE",
      "year-icon": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.noShowModel.date),
      callback: function($$v) {
        _vm.noShowModel.date = $$v
      },
      expression: "noShowModel.date"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-3": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "input-checkbox input-booking",
    attrs: {
      "label": "Facturar",
      "color": "info",
      "hide-details": ""
    },
    model: {
      value: (_vm.noShowModel.flagBilling),
      callback: function($$v) {
        _vm.noShowModel.flagBilling = $$v
      },
      expression: "noShowModel.flagBilling"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "pr-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-cancel grey",
    nativeOn: {
      "click": function($event) {
        _vm.closeBookingModal('NoShow')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tCancelar\n\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "pl-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-save",
    nativeOn: {
      "click": function($event) {
        _vm.noShowBooking($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tAceptar\n\t\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "783px"
    },
    model: {
      value: (_vm.modalSeeBooking),
      callback: function($$v) {
        _vm.modalSeeBooking = $$v
      },
      expression: "modalSeeBooking"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline py-2 pl-5"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "text-xs-left": ""
    }
  }, [_c('p', {
    staticClass: "headline-title"
  }, [_vm._v("\n\t\t\t\t\t\t\tVisualizar reserva\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "text-xs-right": "",
      "pl-0": ""
    }
  }, [_c('label', {
    staticClass: "headline-label"
  }, [_vm._v("\n\t\t\t\t\t\t\tBooking ID:\n\t\t\t\t\t\t")]), _vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.seeModel.numReservation) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "text-xs-right": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "grey",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.closeBookingModal('See')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "px-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "bar-data"
  }, [_c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\tFecha de reserva:\n\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm._f("parseDate")(_vm.seeModel.bookingDate)))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\tLlegada:\n\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm._f("parseDate")(_vm.seeModel.bookingStart)))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\tSalida:\n\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm._f("parseDate")(_vm.seeModel.bookingEnd)))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\tNoches:\n\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.seeModel.numberNights))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item no-border"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\tHuésped:\n\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.seeModel.quantity))])])])])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "px-4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": "",
      "ml-1": ""
    }
  }, [_c('v-btn', {
    staticClass: "blue--text",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.goToCheckIn(_vm.customerInfo.room.comSubsidiaryId,
          _vm.customerInfo.room.hotMsRoomtypeId)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tEditar Clientes\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mb-2": "",
      "text-xs-left": "",
      "px-5": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "modal-label"
  }, [_vm._v("\n\t\t\t\t\t\t\tNº Tarjeta\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "modal-text mt-2"
  }, [_vm._v(_vm._s(_vm.seeModel.customer.data.cardVip))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "modal-label"
  }, [_vm._v("\n\t\t\t\t\t\t\tTipo de identificación\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "modal-text mt-2"
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.seeModel.customer.data.documentName) + ":\n\t\t\t\t\t\t\t" + _vm._s(_vm.seeModel.customer.data.numDocument) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "modal-label"
  }, [_vm._v("\n\t\t\t\t\t\t\tApellidos y Nombres\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "modal-text mt-2"
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.seeModel.customer.data.lastname) + ",\n\t\t\t\t\t\t\t" + _vm._s(_vm.seeModel.customer.data.name) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "modal-label"
  }, [_vm._v("\n\t\t\t\t\t\t\tCorreo electrónico\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "modal-text mt-2"
  }, [_vm._v(_vm._s(_vm.seeModel.customer.data.email))])])], 1), _vm._v(" "), (_vm.seeModel.customerAditional) ? _c('v-layout', {
    attrs: {
      "wrap": "",
      "pl-5": "",
      "mb-1": ""
    }
  }, [_c('label', [_vm._v("Huéspedes adicionales:")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.seeModel.customerAditional), function(customerAditional) {
    return _c('v-layout', {
      key: customerAditional.id,
      attrs: {
        "row": "",
        "wrap": "",
        "mb-4": "",
        "text-xs-left": "",
        "px-5": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "modal-label"
    }, [_vm._v("\n\t\t\t\t\t\t\tTipo de identificación\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
      staticClass: "modal-text mt-2"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(customerAditional.documentName) + ":\n\t\t\t\t\t\t\t" + _vm._s(customerAditional.numDocument) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "modal-label"
    }, [_vm._v("\n\t\t\t\t\t\t\tApellidos y Nombres\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
      staticClass: "modal-text mt-2"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(customerAditional.lastname) + ",\n\t\t\t\t\t\t\t" + _vm._s(customerAditional.name) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('p', {
      staticClass: "modal-text mt-4"
    }, [_vm._v(_vm._s(customerAditional.flagPerson))])])], 1)
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider')], 1)], 1), _vm._v(" "), (_vm.seeModel.channel) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "my-4": "",
      "text-xs-left": "",
      "px-5": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-3": ""
    }
  }, [_c('label', {
    staticClass: "modal-label pr-2"
  }, [_vm._v("Segmento:")]), _vm._v(" "), _c('span', {
    staticClass: "modal-text"
  }, [_vm._v(_vm._s(_vm.seeModel.channel.data.name))])]), _vm._v(" "), _vm._l((_vm.seeModel.channel.data.questions), function(value, key) {
    return _c('v-flex', {
      key: key,
      attrs: {
        "xs2": "",
        "mr-3": ""
      }
    }, [_c('label', {
      staticClass: "modal-label"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(key) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
      staticClass: "modal-text mt-2"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(value) + "\n\t\t\t\t\t\t")])])
  })], 2) : _vm._e()], 2), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": "",
      "pr-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-cancel grey",
    nativeOn: {
      "click": function($event) {
        _vm.closeBookingModal('See')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tCerrar\n\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "pl-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-success white--text",
    attrs: {
      "disabled": _vm.expiredReservation
    },
    nativeOn: {
      "click": function($event) {
        _vm.goToUpdateBooking($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tEditar\n\t\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-calendar row-left row-taken-bar"
  }, [_c('span', {
    staticClass: "taken-bar"
  }, [_vm._v("Ocupación")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-calendar row-left row-left-footer"
  }, [_c('p', {
    staticClass: "text-footer"
  }, [_vm._v("Disponible:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-calendar row-left row-left-footer"
  }, [_c('p', {
    staticClass: "text-footer"
  }, [_vm._v("Tarifa:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-calendar row-left row-left-footer"
  }, [_c('p', {
    staticClass: "text-footer text-xs-center px-0"
  }, [_vm._v("Diponibilidad")]), _vm._v(" "), _c('p', {
    staticClass: "text-footer text-xs-center px-0"
  }, [_vm._v("General")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49686237","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/calendar/CmsCalendar.vue
// module id = 1631
// module chunks = 24